var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecorderDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.249,
    height: 19.873,
    viewBox: "0 0 13.249 19.873",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(118, 118, 118)",
    d: "M6.625 13.876a3.277 3.277 0 002.5-1.132 3.883 3.883 0 001.04-2.722V3.855a3.882 3.882 0 00-1.04-2.722 3.327 3.327 0 00-5 0 3.882 3.882 0 00-1.04 2.722v6.167a3.883 3.883 0 001.04 2.722 3.277 3.277 0 002.5 1.132z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(118, 118, 118)",
    d: "M13.03 7.768a.7.7 0 00-1.035 0 .759.759 0 00-.218.542v1.542a5.323 5.323 0 01-1.512 3.812 4.974 4.974 0 01-7.28 0 5.322 5.322 0 01-1.512-3.812V8.31a.759.759 0 00-.218-.542.7.7 0 00-1.035 0 .758.758 0 00-.219.542v1.542a6.872 6.872 0 001.7 4.631 6.331 6.331 0 004.192 2.258v1.59H2.944a.692.692 0 00-.517.229.781.781 0 000 1.084.692.692 0 00.517.229h7.36a.692.692 0 00.517-.229.781.781 0 000-1.084.692.692 0 00-.517-.229H7.36v-1.59a6.331 6.331 0 004.192-2.258 6.871 6.871 0 001.7-4.631V8.31a.758.758 0 00-.222-.542z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecorderDark);
export default __webpack_public_path__ + "static/media/recorder-dark.a0db1844880dc0a8c304c23de61c614b.svg";
export { ForwardRef as ReactComponent };